// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.table-header-actions__form__actions {
    width: 100%;
    display: flex;
}

.table-header-actions-search-form__form {
    display: flex;
    align-items: center;
    position: relative;
}
.table-header-actions-search_input {
    min-width: calc(var(--space-x3) * 8);
    border: 1px solid var(--new-gray-background-color);
    min-height: var( --space-x3 );
    border-radius: 4px;
    background: var( --new-background-color );
    padding-left: var( --space-x3 );    
}

.table-header-actions-search-form__form input:focus {
    outline: none;
}

.table-header-actions-search-form__form span.icon-search {
    position: absolute;
    font-size: calc( var( --space ) + var( --space-quarter ) );
     color: #949F9A; /* TODO change to var */
    margin-left: calc( var( --space ) - var( --space-eighth ) );   
}

.table-header-actions__form__actions_grid-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr;
    gap: 0px 0px;
    padding-bottom: var(--space-and-half);
    grid-template-areas:
    "search middle middle middle add";
}
  
.table-header-actions__form__actions-search { grid-area: search; }

.table-header-actions-search-form__form svg { 
    position: absolute; 
} 
  
.table-header-actions-search-form__form button {
    float: left;
    width: 20%;    
    background: var(--white-color);
    color: var(--primary-very-dark-color);    
    border: none;    
    box-shadow: none;
    cursor: pointer;
}

.table-header-actions-search-form__form button:hover {
    background: var(--white-color);
    box-shadow: none;
}

.table-header-actions__add { 
  grid-area: add; 
  justify-content: flex-end;
}

.table-header-actions__optional-button { 
    grid-area: middle; 
    justify-self: end;
    margin-right: 20px;
  }
  
.table-header-actions__form__actions .icon{
    grid-area: icon;
    margin-right: 8px;
    font-size: 24px;
}

`, "",{"version":3,"sources":["webpack://./src/shared/components/dynamic-table/TableHeaderActions.styles.css"],"names":[],"mappings":";AACA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,oCAAoC;IACpC,kDAAkD;IAClD,6BAA6B;IAC7B,kBAAkB;IAClB,yCAAyC;IACzC,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,0DAA0D;KACzD,cAAc,EAAE,uBAAuB;IACxC,2DAA2D;AAC/D;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,uBAAuB;IACvB,YAAY;IACZ,qCAAqC;IACrC;qCACiC;AACrC;;AAEA,8CAA8C,iBAAiB,EAAE;;AAEjE;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,8BAA8B;IAC9B,qCAAqC;IACrC,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;;AAEF;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB","sourcesContent":["\n.table-header-actions__form__actions {\n    width: 100%;\n    display: flex;\n}\n\n.table-header-actions-search-form__form {\n    display: flex;\n    align-items: center;\n    position: relative;\n}\n.table-header-actions-search_input {\n    min-width: calc(var(--space-x3) * 8);\n    border: 1px solid var(--new-gray-background-color);\n    min-height: var( --space-x3 );\n    border-radius: 4px;\n    background: var( --new-background-color );\n    padding-left: var( --space-x3 );    \n}\n\n.table-header-actions-search-form__form input:focus {\n    outline: none;\n}\n\n.table-header-actions-search-form__form span.icon-search {\n    position: absolute;\n    font-size: calc( var( --space ) + var( --space-quarter ) );\n     color: #949F9A; /* TODO change to var */\n    margin-left: calc( var( --space ) - var( --space-eighth ) );   \n}\n\n.table-header-actions__form__actions_grid-container {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    grid-template-rows: 1fr;\n    gap: 0px 0px;\n    padding-bottom: var(--space-and-half);\n    grid-template-areas:\n    \"search middle middle middle add\";\n}\n  \n.table-header-actions__form__actions-search { grid-area: search; }\n\n.table-header-actions-search-form__form svg { \n    position: absolute; \n} \n  \n.table-header-actions-search-form__form button {\n    float: left;\n    width: 20%;    \n    background: var(--white-color);\n    color: var(--primary-very-dark-color);    \n    border: none;    \n    box-shadow: none;\n    cursor: pointer;\n}\n\n.table-header-actions-search-form__form button:hover {\n    background: var(--white-color);\n    box-shadow: none;\n}\n\n.table-header-actions__add { \n  grid-area: add; \n  justify-content: flex-end;\n}\n\n.table-header-actions__optional-button { \n    grid-area: middle; \n    justify-self: end;\n    margin-right: 20px;\n  }\n  \n.table-header-actions__form__actions .icon{\n    grid-area: icon;\n    margin-right: 8px;\n    font-size: 24px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
